var PageHomeEntryForm = /** @class */ (function () {
    //inputList: Array<HTMLInputElement>;
    //Methods
    function PageHomeEntryForm(target) {
        var thisObj = this;
        //Assign elements
        this.target = target;
        //this.inputList = Apfco.ConvertNodeListToArray(this.target.querySelectorAll('input')) as Array<HTMLInputElement>;
        //console.log(this.inputList);
        //console.log('Root URL: ' + GlobalRootUrl);
        //this.SleepTest();
    }
    return PageHomeEntryForm;
}());
//On page load, take all elements with the classname and create objects for them
var PageHomeEntryFormList = [];
$(function () {
    var PageHomeEntryFormsByClass = document.getElementsByClassName("pageHomeEntryForm");
    for (var i = 0; i < PageHomeEntryFormsByClass.length; i++) {
        PageHomeEntryFormList.push(new PageHomeEntryForm(PageHomeEntryFormsByClass.item(i)));
    }
    ;
});
//# sourceMappingURL=PageHomeEntryForm.js.map